import {ParsedUrlQuery} from 'querystring';

import {CreateAccountParams} from './CreateAccount.types';

export const parseQueryParams = (query: ParsedUrlQuery): CreateAccountParams => {
  const email = query.email as string;
  const firstName = query.firstname as string;
  const lastName = query.lastname as string;
  const returnUrl = query.return_to as string;
  const autoVerify = ((query.autoverify as string) || '').toLowerCase() === 'true';
  const isGiftedKitRecipient = String(query.from_gift_testkit).toLowerCase() === 'true';

  return {
    email,
    firstName,
    lastName,
    returnUrl,
    autoVerify,
    isGiftedKitRecipient,
  };
};
